import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proteccion',
  templateUrl: './proteccion.component.html',
  styleUrls: ['./proteccion.component.scss']
})
export class ProteccionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void  {
  }

}
